import { useQuery } from '@tanstack/react-query';

import { queryOptions } from '~components/hooks/_constants';
import { useContractVestaEIR } from '~components/hooks/contracts';
import { useGraphStatus } from '~components/hooks/useGraphStatus';
import { useSession } from '~components/hooks/useSession';
import { checkValidContractAddress } from '~config/protocol';
import { EVestaAsset } from '~config/types';

export const vaultInterestRateKey = 'vault-interest-rate-key';

export const useVaultInterestRate = (asset: EVestaAsset) => {
  const { network } = useSession();
  const { data: isGraphFetchable } = useGraphStatus();

  const { read: interestRateRead, address: interestRateAddress } = useContractVestaEIR(asset);

  const queryKey = [vaultInterestRateKey, network.networkId, asset, isGraphFetchable ? 'graph' : 'chain'];

  const result = useQuery<number>(
    queryKey,
    async () => {
      const interestRateRaw = await interestRateRead.currentEIR();

      return Number(interestRateRaw) / (100 * 100);
    },
    queryOptions(false, checkValidContractAddress(interestRateAddress)),
  );

  return { ...result, data: result.data ?? 0 };
};
